import React from 'react';
import Grid from '@material-ui/core/Grid';
import clsx from 'clsx';
import TextField from '@material-ui/core/TextField';
import { makeStyles } from '@material-ui/core/styles';
import {Elements, StripeProvider} from 'react-stripe-elements';
import StripeCreditCard from './../genericComponents/StripeCreditCard';

// class ReviewYourOrder extends Component {
//   render() {
//     return (
//       <StripeProvider apiKey="pk_test_TYooMQauvdEDq54NiTphI7jx">
//         <div className="example">
//           <h1>React Stripe Elements Example</h1>
//           <Elements>
//             <StripeCreditCard />
//           </Elements>
//         </div>
//       </StripeProvider>
//     );
//   }
// }

// export default ReviewYourOrder;

const useStyles = makeStyles(theme => ({
    textField: {
        // marginLeft: theme.spacing(1),
        // marginRight: theme.spacing(1),
    },
    dense: {
        backgroundColor: 'white',
    },
}));


const Checkout = () => {
    const classes = useStyles();
    return (
        <Grid container direction="column" spacing={2}>
            <h2>Check-Out:</h2>
            <Grid item xs={12}>
                <TextField id="outlined-dense"
                    label="Email Address"
                    className={clsx(classes.textField, classes.dense)}
                    margin="dense"
                    variant="outlined"
                    fullWidth={true} />
            </Grid>
            <Grid item xs={12}>
                <StripeProvider apiKey="pk_test_TYooMQauvdEDq54NiTphI7jx">
                    <Elements>
                        <StripeCreditCard />
                    </Elements>
                </StripeProvider>
            </Grid>
            <Grid item xs={12}>
                <TextField id="outlined-dense"
                    label="Name on card"
                    className={clsx(classes.textField, classes.dense)}
                    margin="dense"
                    variant="outlined"
                    fullWidth={true} />
            </Grid>
            <Grid item xs={12}>
                <TextField id="outlined-dense"
                    label="Country"
                    className={clsx(classes.textField, classes.dense)}
                    margin="dense"
                    variant="outlined"
                    fullWidth={true}
                    select={true} />
            </Grid>
        </Grid>
    )
};

export default Checkout;